import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectLoggedIn } from './auth/authSlice';

function PrivateRoute({ children, ...rest }) {
  const loggedIn = useSelector(selectLoggedIn);

  return (
    <Route {...rest} render={({ location }) => {
      return loggedIn
        ? children
        : <Redirect to={{
          pathname: '/login',
          state: { from: location }
        }} />
    }} />
  )
}

PrivateRoute.propTypes = {
  children: PropTypes.any,
};

export default PrivateRoute;
